import { useParams } from "react-router-dom";
import CampaignHeader from "./CampaignHeader";
import CampaignBasicInfo from "./CampaignBasicInfo";
import CampaignPaymentInfo from "./CampaignPaymentInfo";
import useGetCampaignById from "../utils/useGetCampaignById";
import Header from "./Header";
import Footer from "./Footer";
import CampaignDescription from "./CampaignDescription";

const CampaignDetails = () => {
  const params = useParams();
  const { id } = params;
  const [campaignData] = useGetCampaignById(id);
  return (
    <>
      <Header />
      <div className="main-panel" style={{ backgroundColor: "#f4f8fb" }}>
        <div className="container">
          <CampaignHeader campaignData={campaignData?.campaign} />
          <CampaignDescription
            campaignDescription={campaignData?.campaign?.campaignDescription}
          />
          <div className="row">
            <div className="col-md-6">
              <CampaignBasicInfo campaignData={campaignData?.campaign} />
            </div>
            <div className="col-md-6">
              <CampaignPaymentInfo campaignData={campaignData?.campaign} />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CampaignDetails;
